import { ICalculator } from './interfaces'

export const setCalc = (calc: ICalculator) => ({
  type: 'SET_CALC',
  payload: {
    calc
  }
})
